import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem } from '@mui/material';
import React from 'react';
import { SelectDefault } from 'app/shared/components/select-default/SelectDefault';
import { TireFunction } from 'app/shared/model/enumerations/tire-function.model';
import { translate } from 'react-jhipster';

interface VehicleModelTireFunctionModalProps {
  open: boolean;
  tireCount: number;
  tireFunction: Record<number, TireFunction>;
  setTireFunction: React.Dispatch<React.SetStateAction<Record<number, TireFunction>>>;
  onClose: () => void;
  onSave: () => void;
}

export const VehicleModelTireFunctionModal = ({
  open,
  tireCount,
  tireFunction,
  setTireFunction,
  onClose,
  onSave,
}: VehicleModelTireFunctionModalProps) => {
  const handleTireFunctionChange = (position: number, value: TireFunction) => {
    setTireFunction(previous => ({
      ...previous,
      [position]: value,
    }));
  };

  const tireFunctionOptions = Object.entries(TireFunction).filter(
    ([, value]) => value !== TireFunction.NULL
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        Função dos pneus
      </DialogTitle>

      <DialogContent
        sx={{
          overflowY: 'auto',
          maxHeight: '60vh',
        }}
      >
        <Box sx={{ mt: 1 }}>
          {Array.from({ length: tireCount }, (_, index) => {
            const position = index + 1;

            return (
              <Box
                key={position}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  mb: 2,
                }}
              >
                <Box
                  sx={{
                    minWidth: 80,
                    whiteSpace: 'nowrap',
                    fontWeight: 500,
                  }}
                >
                  Posição {position}:
                </Box>

                <SelectDefault
                  fullWidth
                  value={tireFunction[position] ?? ''}
                  onChange={event =>
                    handleTireFunctionChange(
                      position,
                      event.target.value as TireFunction
                    )
                  }
                >
                  {tireFunctionOptions.map(([key, value]) => (
                    <MenuItem value={value} key={key}>
                      {translate(`fleetSenseApp.TireFunction.${value}`)}
                    </MenuItem>
                  ))}
                </SelectDefault>
              </Box>
            );
          })}
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          px: 3,
          py: 2,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'flex-end',
            gap: 2,
          }}
        >
          <Button
            variant="contained"
            color="secondary"
            onClick={onClose}
          >
            Cancelar
          </Button>

          <Button
            variant="contained"
            color="primary"
            onClick={onSave}
          >
            Salvar
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default VehicleModelTireFunctionModal;